<template>
  <div>
    <div class="row zero-height">
<!-- 
      <div class="col-md-auto ml-auto" style="position: relative; top: 5rem; z-index: 10;">
        <div
          v-if="completeData"
          role="button"
          class="btn-result"
          :class="{ active: hideNavigation }"
          @click="onToogleResult"
        >
          <img
            class="mr-2"
            alt="Result"
            src="../../assets/summary.png"
          />
          Result
        </div>
      </div>  -->
    </div>
    <ProgressBar 
      v-if="!hideNavigation"
      :groups.sync="groups" 
      :completeData="completeData" 
      :answers.sync="answers"
      class="mt-0"
    />
  </div>
</template>

<script lang="ts">
import { Answer } from "@/entities/questionaire/answers/Answer";
import { Group } from "@/entities/questionaire/Group";
import { Property } from "@/entities/questionaire/Property";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ProgressBar from "./ProgressBar.vue";

@Component({
  components: {
    ProgressBar,
  },
})
export default class AppQuestionProgress extends Vue {
  public localQuestions: Property[] = [];
  private localQuestionCount: number = 0;

  @Prop()
  questionNo!: number | 1;

  @Prop()
  questionCount!: number | 1;

  @Prop({ default: false }) 
  showButton!: boolean;

  @Prop()
  hideNavigation!: boolean | false;

  @Prop()
  completeData!: boolean | false;

  @Prop()
  onToogleResult!: any;

  @Prop()
  branchId!: number | null;
  private localBranchId: number | null = null;

  @Prop()
  groups!: Group[] | null;
  private localGroups: Group[] | null = this.groups;

  @Prop()
  answers!: Answer[] | null;
  private localAnswers: Answer[] = [];

  @Prop()
  currentQuestionId!: number | null;

  @Prop({ default: true }) viewable!: boolean;

  created() {
    this.localBranchId = this.branchId;
    this.localGroups = [...(this.groups ?? [])];
    this.localAnswers = [...(this.answers ?? [])];

    this.updateGroups();
  }

  updateGroups() {
    this.localAnswers = [];

    this.localQuestions = [];

    if (this.groups) {
      for (let i = 0; i < this.groups.length; i++) {
        var group = this.groups[i];
        group.properties.forEach((p) => {
          this.localQuestions.push(p);
        });
      }
    }

    this.localQuestionCount = this.localQuestions.length;
  }

  back(): void {
    this.$events.emit("onSetPreviousQuestion");
  }

  next(): void {
    this.$events.emit("onSetNextQuestion");
  }

  hasAnswer(propertyId: any) {
    const answer = this.localAnswers.find((x) => x.PropertyId == propertyId);
    return answer;
  }

  @Watch("groups")
  onGroupsChanged() {
    this.localGroups = this.groups ?? [];

    this.updateGroups();
  }
  mounted() {
    this.$events.on("showBackButton", () => {
      // Setze showButton auf true, um den Button anzuzeigen
      this.showButton = true;
    });
  }
  
}
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@500&display=swap");

button {
  // width: 107px;
  // height: 26px;
  // left: 729px;
  // top: 125px;
  margin-bottom: 2px;

  background: #dfeefd;
  border-radius: 46px;
  border: none;
  color: #014185;

//  font-family: "Inter";
  font-family: 'Albert Sans', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;

  &:hover {
    background: #dfeefd;
    color: #014185;
  }

  &:disabled {
    background: #dfeefd;
    color: gray;
  }
}

label {
  //font-family: "Inter";
  font-family: 'Albert Sans', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 150%;
}

hr {
  margin-top: 2rem;
  background-color: #dae4ee;
}

.b-icon {
  font-size: 90% !important;
  vertical-align: middle !important;
}

.btn-result {
  background: #2289e9;
  box-shadow: 0px 4px 15px rgba(0, 45, 113, 0.25);
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 46px;
  color: #ffffff;

  &.active {
    border-radius: 25px 25px 0 0;
  }
}

.progress-bar-wrapper {
  display: flex;
  margin-top: 0.75rem;
}

.progress-bar-item {
  display: inline-block;
  border: 1px solid #a4c2f4;
  height: 15px;
  margin-left: 2px;

  &.active {
    border: 2px solid #6094ec;
  }

  &.answered {
    background-color: #a4c2f4;
  }
}

.btn-next {
  margin-left: 4px;
}

.col-md-6 {
  flex: auto;
}

.progress-bar-container {
  margin-top: 10px;
  padding-right: 15px !important;
}

.result-container {
  position: absolute;
  left: 300px; 
}

.btn-text {
  display: inline-block;
}

.col-md-3 {
  flex: 0 0 55%;
  max-width: 55%;
}

.row {
  flex-wrap: wrap;
}

/* In Ihrer CSS-Datei */
.zero-height {
  height: 0px;
}

.col-md-6 {
  max-width: 100%;
}

@media only screen and (max-width: 400px) {
  .btn-text {
    display: none;
  }
}
</style>
